import {useEffect} from 'react';
import activityTracker from '../lib/activity-tracker';


export default function ActivityTrackerIframe() {

    useEffect(() => {
        const listener_type = 'message';
        const trackActivity = (msg: MessageEvent) => {
            // SECURITY: Strict origin validation - prevent origin bypass attacks
            const expectedOrigin = window.location.protocol + '//' + process.env.REACT_APP_TI_DOMAIN;
            if (msg.origin === expectedOrigin) {
                const msgData = msg.data;
                // Validate message structure
                if (msgData && typeof msgData === 'object' && msgData.toolName && msgData.pageName) {
                    activityTracker.setRecentActivity(msgData.toolName, msgData.pageName, undefined, msgData.pageUrl);
                }
            }
        };

        window.addEventListener(listener_type, trackActivity);

        return () => window.removeEventListener(listener_type, trackActivity);
    }, []);

    return <div></div>;
}